import styled from "styled-components";

const ActionIcon = styled.i`
  margin-right: 5px;
`;

export { ActionIcon };
